import type { VAxios } from '../../define/axios/Axios';

/**
 * 登录相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 提交合作意向
  cooperations: (params) => {
    return defHttp.post({
      url: `/website/cooperations`,
      params,
    });
  },
});
